import React from 'react'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((theme) => ({
  container: {
    background: 'rgba(250, 250, 250, 0.8)',
    position: 'fixed',
    zIndex: '100',
    left: '0px',
    bottom: '0px',
    width: '100%',
    height: 'auto',
    minHeight: '90px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 20px',

    [`@media (max-width: ${theme.breakpoints.L})`]: {
      padding: '10px 60px',
    },
    [`@media (max-width: ${theme.breakpoints.M})`]: {
      padding: '10px 20px',
    },
  },
}))

type DataProps = {
  children: React.ReactChild
}

const FixedFooterWrapper: React.FC<DataProps> = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.container}>{children}</div>
}

export default FixedFooterWrapper
